<template>
  <Suspense>
    <template #default>
      <!--my-map></my-map-->
      <router-view></router-view>
    </template>

    <template #fallback>
      <div>Loading the map...</div>
    </template>
  </Suspense>
</template>

<script setup lang="ts">
import MyMap from '@/views/map/Map.vue'
</script>
